(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;
  const settings = document.querySelector('script[data-yam-widget-localization]');
  if (!settings) return;
  const labels = new Map([['More', settings.dataset.moreLabel], ['Sort by', settings.dataset.sortLabel]]);
  function init() {
    document.querySelectorAll('.jdgm-review-widget').forEach(widget => {
      const translate = () => {
        widget.querySelectorAll('.jdgm-visually-hidden').forEach(node => {
          const label = labels.get(node.textContent.trim());
          if (label && node.textContent !== label) node.textContent = label;
        });
      };
      translate();
      let pending = false;
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        queueMicrotask(() => { pending = false; translate(); });
      });
      observer.observe(widget, {childList: true, subtree: true, characterData: true});
      window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
